import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="w-full bg-primary-600 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:items-center">
          <div className="lg:col-span-7">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-balance">
              遇到直播争议，别再让线索沉下去
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100/90 max-w-2xl">
              提交后拿到受理编号，24 小时内确认受理，核查进度与处理结果全程同步。举报人信息严格保密，处理结果进入公开公示区。
            </p>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row lg:justify-end gap-3">
            <Link
              to="/report"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-base font-medium bg-background-50 text-primary-700 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-live-line" aria-hidden="true"></i>
              提交举报线索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-base font-medium border border-background-100/40 text-background-50 hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              了解平台原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}